import { convertDateRangeToDates } from "@wingspanhq/fe-component-library";
import { ApiQueryListWorkLogs } from "../../../../../services/workLog";
import { Filter } from "./types";

export function createListRequest(
  _userId: string,
  filter?: Filter
): ApiQueryListWorkLogs {
  const request: ApiQueryListWorkLogs = {};

  if (filter?.payerId) {
    request["filter[payerId]"] = filter.payerId;
  }

  // switch (filter?.status) {
  //   case "in-progress":
  //     request["filter[invoiceId][exists]"] = false;
  //     break;
  //   case "submitted":
  //     request["filter[invoiceId][exists]"] = true;
  //     break;
  // }

  if (filter?.dateRange) {
    const dateRange = convertDateRangeToDates(filter.dateRange);
    if (dateRange) {
      request["filter[startDate][>]"] = dateRange.start;
      request["filter[startDate][<]"] = dateRange.end;
    }
  }

  return request;
}
